import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";

import { map } from "rxjs/operators";
import { GroupForm } from "app/interfaces/group-form.interface";

const groupsUrlApi = environment.groupsUrlApi;
const groupsAssignRolesUrlApi = environment.groupsAssignRolesUrlApi;
const groupsByUserUrlApi = environment.groupsByUserUrlApi;

@Injectable()
export class GroupService {
  public user: GroupForm;

  constructor(private http: HttpClient) {}

  getGroups() {
    return this.http
      .request("GET", `${groupsUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getGroupByUser(id: number) {
    const body = { lang: "ES" };
    return this.http
      .request("GET", `${groupsByUserUrlApi}/` + id, { body })
      .pipe(map((resp: any) => resp));
  }

  getGroupById(id: number) {
    return this.http
      .request("GET", `${groupsUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  updateGroupById(id: number, groupModel: GroupForm) {
    const body = groupModel;
    return this.http
      .request("PUT", `${groupsUrlApi}/` + id, { body })
      .pipe(map((resp: any) => resp));
  }

  createGroup(groupModel: GroupForm) {
    const body = groupModel;
    return this.http
      .request("POST", `${groupsUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  assignRoles(idGroup: number, arrayRolesSelected) {
    const body = { id_roles: arrayRolesSelected };
    return this.http
      .request("PUT", `${groupsAssignRolesUrlApi}/` + idGroup, { body })
      .pipe(map((resp: any) => resp));
  }

  deleteGroupById(id: number) {
    return this.http
      .request("DELETE", `${groupsUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }
}
